export const SIDEBAR_COLORS = {
  textPrimary: 'var(--palette-semantic-text-primary)',
  textSecondary: 'var(--palette-semantic-text-caption)'
} as const;

export const thinScrollbarSx = {
  '&::-webkit-scrollbar': {
    width: '6px'
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'var(--palette-primitive-gray-200)',
    borderRadius: '100px'
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: 'var(--palette-primitive-gray-300)'
  }
} as const;
